var map = {
	"./goldcoin/join-icon-frens.png": 74770,
	"./memetown/join-icon-frens.png": 18555,
	"./reflection/join-icon-frens.png": 59495,
	"./tapcoin/join-icon-frens.png": 25786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45310;